export const daysOptions = [
  { value: "0", label: "Sunday", shortLabel: "SU" },
  { value: "1", label: "Monday", shortLabel: "MO" },
  { value: "2", label: "Tuesday", shortLabel: "TU" },
  { value: "3", label: "Wednesday", shortLabel: "WE" },
  { value: "4", label: "Thrusday", shortLabel: "TH" },
  { value: "5", label: "Friday", shortLabel: "FR" },
  { value: "6", label: "Saturday", shortLabel: "SA" },
];
